import Cookies from 'js-cookie';
export const READ_ONLY_KEY = 'isReadOnly';
export const READ_ONLY_ERROR_CODE = 'read_only_mode';
export const setReadOnlyMode = () => Cookies.set(READ_ONLY_KEY, 'true', {
  expires: 5 / (24 * 60)
});
export const unsetReadOnlyMode = () => Cookies.remove(READ_ONLY_KEY);